export type CommunityRoomTypesProps = {
  hasBusinessCenter: boolean;
  hasClubHouse: boolean;
  hasConferenceRoom: boolean;
  hasFitnessCenter: boolean;
  hasGameRoom: boolean;
  hasLibrary: boolean;
  hasLounge: boolean;
  hasPartyRoom: boolean;
  hasPetWashingStation: boolean;
  hasTheater: boolean;
};

const CommunityRoomTypes = ({
  hasBusinessCenter = false,
  hasClubHouse = false,
  hasConferenceRoom = false,
  hasFitnessCenter = false,
  hasGameRoom = false,
  hasLibrary = false,
  hasLounge = false,
  hasPartyRoom = false,
  hasPetWashingStation = false,
  hasTheater = false,
} = {}) => ({
  hasBusinessCenter: Boolean(hasBusinessCenter),
  hasClubHouse: Boolean(hasClubHouse),
  hasConferenceRoom: Boolean(hasConferenceRoom),
  hasFitnessCenter: Boolean(hasFitnessCenter),
  hasGameRoom: Boolean(hasGameRoom),
  hasLibrary: Boolean(hasLibrary),
  hasLounge: Boolean(hasLounge),
  hasPartyRoom: Boolean(hasPartyRoom),
  hasPetWashingStation: Boolean(hasPetWashingStation),
  hasTheater: Boolean(hasTheater),
});

export default CommunityRoomTypes;
